module.exports = __webpack_public_path__ + "static/media/6.70d0e0f4.png";